import React, { Component } from 'react'
import Icon from '@mui/material/Icon'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSatelliteDish } from '@fortawesome/free-solid-svg-icons'
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import { ReactComponent as EmployeeIcon } from './../../assets/nav/employees-one.svg'
import { Link } from 'react-router-dom'
import { checkPrivileges } from '../../Helpers'
import { ReactComponent as IntegratedWasl } from '../../assets/monitoring/wasl.svg'
import { ReactComponent as NotIntegratedWasl } from '../../assets/monitoring/wasl-cross.svg'
;
import Style from 'style-it'
library.add(faSatelliteDish)

class Driver extends Component {
  render () {
    let data = ''
    if (this.props.items.length) {
      data = this.props.items.map(driver => (
        <ListRow
          key={driver.id}
          item={driver}
          {...this.props}
          removedItem={this.props.removedItem}
          editItem={this.props.editItem}
          selecteItem={this.props.selecteItem}
        />
      ))
    }
    return (
      <Style>
        {`
  .material-icons {vertical-align: middle; color: inherit}
`}
        <div>
          {data && (
            <div className='individual-view'>
              <ul className='list-view with-padding-right'>{data}</ul>
            </div>
          )}
        </div>
      </Style>
    )
  }
}

export class ListRow extends Component {
  render () {
    const device = this.props.allDriverLocation && this.props.allDriverLocation[this.props.item.id] || null;
    const { waslEnabled } = this.props?.ServerSetting?.attributes || {};

    const { id, name, attributes: { WASLKey } } = this.props.item;
    return (
      <li>
        <Link
          className={
            'clearfix list-row ' +
            (parseInt(this.props.match.params.id) ===
            parseInt(id)
              ? 'active'
              : '')
          }
          to={'/drivers/' + id}
        >
          <label
            className='checkbox'
            onClick={() => this.props.selecteItem(this.props.item)}
          >
            <span
              className='unit-name'
            >
              <span
                style={{
                  marginRight: '5px',
                  display: 'inline-block',
                  verticalAlign: 'middle'
                }}
              >
                <EmployeeIcon fill="currentColor" style={{width: 16, height: 16, verticalAlign: 'middle'}}/>
              </span>
              {name}
            </span>
          </label>
          <div className='pull-right'>
            {waslEnabled ? (WASLKey ? <IntegratedWasl width={32} style={{fill: 'currentColor'}} /> : <NotIntegratedWasl width={32} style={{fill: 'currentColor'}} />) : ''}
            
            {checkPrivileges('driverDelete') && (
              <span
                className='action-item hovered'
                title={this.props.translate('delete')}
                onClick={e => this.props.removedItem(this.props.item)}
              >
                <DeleteIcon style={{fontSize: 16}}/>
              </span>
            )}            
            {checkPrivileges('driverUpdate') && (
              <span
                className='action-item hovered'
                title={this.props.translate('edit')}
                onClick={() => this.props.editItem(this.props.item)}
              >
                <EditIcon style={{fontSize: 16}}/>
              </span>
            )}
            {device ? (
              <span>
                <img
                    width={24}
                    height={24}
                    src={
                      '/assets/category/default/'+(device.category ||
                        'default')+'.svg'}
                    
                    alt=''
                  />
              </span>
            ) : <span
            className='action-item'
          >
            <LinkOffIcon style={{fontSize: 16}}/>
          </span>}
          </div>
        </Link>
      </li>
    )
  }
}

export const DriversShortList = (Driver)
